import { getSignedGetUrl } from './b2';

const cache       = new Map();
const cacheTimers = new Map();

function setCached(storageLocation, url) {
  clearTimeout(cacheTimers.get(storageLocation));
  cache.set(storageLocation, url);
  const t = setTimeout(() => {
    cache.delete(storageLocation);
    cacheTimers.delete(storageLocation);
  }, 50 * 60 * 1000);
  cacheTimers.set(storageLocation, t);
}

export async function resolveB2Url(storageLocation) {
  if (!storageLocation?.startsWith('b2://')) return null;
  if (cache.has(storageLocation)) return cache.get(storageLocation);

  const key = storageLocation.replace(/^b2:\/\/[^/]+\//, '');
  const url = await getSignedGetUrl(key);
  setCached(storageLocation, url);
  return url;
}

export async function refreshB2Url(storageLocation) {
  if (!storageLocation?.startsWith('b2://')) return null;
  const key = storageLocation.replace(/^b2:\/\/[^/]+\//, '');
  const url = await getSignedGetUrl(key);
  setCached(storageLocation, url);
  return url;
}
